import { useNavigate, useParams } from 'react-router-dom';
import Producto from '../components/productos/Producto';
import { useContext, useEffect, useState } from 'react';
import { fetchProductData, fetchProductListData } from '../services/ProductServices';
import { AuthContext } from '../services/AuthContext';
import ErrorPage from './ErrorPage';
import { Alert, Spinner } from 'react-bootstrap';
import ProductList from '../components/productos/ProductoList';

export default function ProductoAmpliado(){
  const { productInfo } = useParams();
  const [productId, ...productNameParts] = productInfo.split('-');
  const navigate = useNavigate();

  const [productoData, setProductoData] = useState({variaciones: [],observaciones:''})
  const { user, cart, isAuthenticated  } = useContext(AuthContext);
  const [visibleError, setVisibleError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [ variant, setVariant ] = useState('danger');
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [category, setCategory] = useState('');
  const [cartSelected, setCartSelected] = useState(true);

  // Función para actualizar el mensaje
  const handleMessage = (message) => {
    setMessage(message);
  };

  const handleVariant = (message) => {
    setVariant(message);
  };

  const handleVisible = (value) => {
    setVisibleError(value);
    setVariant('danger')
  }

  useEffect(()=>{
    setLoading(true);
    let param = {
      id: productId,
    }
    if (user) {
      param = {
        ...param,
        user: user.id
      }
    }
    fetchProductData(param)
      .then(data => {
        if (data.estado_id != 1) {
          navigate(sessionStorage.getItem('prevState'))
        } else { 
          setProductoData(data);
          setCategory(data.categoria_id);
          if (cart) {
            const index = cart.findIndex(prod => prod.producto_id == productId)
            if (index > -1) {
              setProductoData((prevData) =>
                data.variaciones.length > 0 ?
                  {
                    ...prevData,
                    observaciones: cart[index].observaciones,
                    variaciones: cart[index].variaciones.reduce((newVariaciones, vari) => {
                      const existingVari = prevData.variaciones.find(it => it.id === vari.id);
        
                      if (existingVari) {
                        // Si la variación existe, actualizamos su valor
                        return newVariaciones.map(varIt => 
                          varIt.id === vari.id
                            ? { ...varIt, 
                              inCart: vari.cantidad
                            }
                            : varIt
                        );
                      }
                    }, [...prevData.variaciones])
                  }
                : {...prevData,
                  observaciones: cart[index].observaciones,
                  inCart: cart[index].cantidad
                }
              )
            }
          }
        }
      })
      .catch(err => {
        setVisibleError(true)
        setMessage(err.data)
        setVariant('danger')
      })
      .finally(()=>{setLoading(false)})
  }, [productId, cart])

  useEffect(()=>{
    if (category) {
      let param = {
        categoria: category,
        notId: productoData.id,
        estado: 1,
        max: 4,
      }
      if (user) {
        param = {
          ...param,
          user: user.id,
          isSeller: user.isSeller,
        }
        if (user.isSeller && (user.clientSelected && user.clientSelected != 0)) {
          param = {
            ...param,
            clientId: user.clientSelected
          }
        }
      }
      fetchProductListData(param)
      .then((data)=>{
        setRelatedProducts(data.productos);
      })
    }
  
  },[category, productoData.id])

  useEffect(()=>{
    if (!cartSelected) {
      setMessage('No hay cliente seleccionado. No podra armar ningun carrito.')
      setVariant('warning')
      setVisibleError(true)
    }
  },[cartSelected])

  useEffect(() => {
    window.scrollTo(0,0)
    if (isAuthenticated) {
      setCartSelected(user && (!user.isSeller || (user.clientSelected > 0)))
    }
  },[])

  const keepShopping = () => {
    localStorage.removeItem('productoAgregado');
    navigate(sessionStorage.getItem('prevState'));
  }

  return (
    <div className='content-wrap'>
      {loading ?
        <div className='content-loading'>
          <Spinner variant='success' />
        </div>
        :
        <>
          <Alert variant={variant} dismissible show={visibleError} onClose={() => setVisibleError(false)}>
            {message}
          </Alert>
          {productoData.id ? 
            <>
              <Producto 
                prod={productoData}
                onMessage={handleMessage} 
                onVisible={handleVisible} 
                setVariantAlert={handleVariant}
                onKeepShopping={keepShopping}
                cartSelected={cartSelected}
              />
              {relatedProducts.length > 0
                ? <div className='catalog-carousel'>
                    <ProductList title={"Productos Relacionados"} items={relatedProducts} color={'background-light-blue'} onVisible={handleVisible} onMessage={handleMessage} />
                  </div>
                : null
              }
            </>
            : <ErrorPage errorMessage={`No existe un producto con ese id`}/>
          }
        </>
      }
    </div>
  );
}